((Drupal) => {
  "use strict";

  // Dynamically updating the displayed class name based on the selected
  // option in a dropdown menu within the teacher bookshelf filter form.
  const bookshelfSelect = (context) => {
    const selectElementWrapper = context.querySelector(
      "#teacher-bookshelf-filter-form"
    );
    const selectElement = context.querySelector("#edit-class");
    const outputDiv = context.querySelector(".class-name");

    if (!selectElementWrapper || !selectElement || !outputDiv) return;

    // Updates the content of the output div to display the currently selected option's text.
    const updateOutput = () => {
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      outputDiv.textContent = selectedOption.textContent;
    };

    updateOutput();
    selectElement.addEventListener("change", updateOutput);
  };

  Drupal.behaviors.bookshelfSelect = {
    attach(context) {
      bookshelfSelect(context);
    },
  };
})(Drupal);
